import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import usageLogAxios from '../../axios/UsageLog'

export const fetchUsageLog = filterOptions => {
  return dispatch => {
    const params = {
      action: filterOptions.action,
      page: filterOptions.page ? filterOptions.page : 1,
      perPage: filterOptions.perPage ? filterOptions.perPage : 10
    }

    dispatch(fetchUsageLogStart())

    usageLogAxios
      .get(`/${filterOptions.start_date}/${filterOptions.end_date}`, { params })
      .then(response => {
        if (response.status === 200) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })
          dispatch(fetchUsageLogSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchUsageLogFailed(error))
      })
  }
}

export const fetchUsageLogStart = () => {
  return {
    type: actionTypes.FETCH_USAGE_LOG_START
  }
}

export const fetchUsageLogSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_USAGE_LOG_SUCCESS,
    pagination,
    records
  }
}

export const fetchUsageLogFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_USAGE_LOG_FAILED,
    errorMessage
  }
}
